import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import BagCloseDetails from './BagCloseDetails/index.vue';
import FalconApiResponseLog from './FalconApiResponseLog/index.vue';
import BagInShipmentLiveResponse from './BagInShipmentLiveResponse/index.vue';
import pushShipmentDataNew from './pushShipmentDataNew/index.vue';
import hubInscanLogs from './hubInscanLogs/index.vue';


export default {
	name: 'sorter',
	components: {
		DatePicker,
		'first': BagCloseDetails,
		'second': FalconApiResponseLog,
		'third':hubInscanLogs,
		'fourth': BagInShipmentLiveResponse,
		'Fifth':pushShipmentDataNew

	},
	props: [],
	data() {
		return {
			currentTab: 'First',
			componentKey: 0,
			tabs: [{
					key: 'First',
					value: 'Bag Close Details'
				},
				{
					key: 'Second',
					value: 'Falcon Api Response Log'
				},
				{
					key: 'Third',
					value: 'Hub Inscan Logs'
				},
				{
					key: 'Fourth',
					value: 'BagIn Shipment Live Response'
				},
				{
					key: 'Fifth',
					value: 'Push Shipment Data New System'
				}
			],
		}
	},
	computed: {
		// selects all checkbox's option
		currentTabComponent: function() {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		}
	},
	mounted() {},
	methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/BhiwandiSorter/BhiwandiSorter.js